import extend from 'lodash/extend';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	data: null,
	loading: false,
	error: null,
};

const { actions, reducer } = createSlice({
	name: 'company',
	initialState,
	reducers: {
		getCompany: (state) => extend(state, { loading: true, error: null }),
		getCompanyFailure: (state, { payload }) =>
			extend(state, { loading: false, error: payload }),
		getCompanySuccess: (state, { payload }) =>
			extend(state, { loading: false, error: null, data: payload }),
	},
});

export const { getCompany, getCompanySuccess, getCompanyFailure } = actions;

export { default as companySaga } from './sagas';

export default reducer;
